import { Flex, InlineBanner, Spinner, Box } from '@cad-arc';
import { ConsolidatedLocationView } from '@mark43/cad-api';
import { useEsriEmbeddedBaseMap } from '../../../esri/base-maps/use-esri-embedded-base-map';
import { ZoomInAndOutControl } from '../../../esri/components/zoom-in-and-out-control';
import { errorOccurredWhile } from '../../../common/helpers/error-occurred-while';
import { useSingleGraphicDisplayLayer } from '../../../esri/hooks/use-single-graphic-display-layer';
import { ESRI_DEFAULT_ICON_LABEL_FONT } from '../../../esri/configurations';
import { getMapIconTheme } from '../../../esri/helpers/map-icon-theme';
import { observer } from 'mobx-react-lite';

const MAP_COMPONENT_HEIGHT = '202px';

export const FrEventPreviewMap = observer(function FrEventPreviewMap({
    eventLocation,
    eventPriority,
}: {
    eventLocation: ConsolidatedLocationView;
    eventPriority: string;
}) {
    const mapCenter = {
        latitude: eventLocation?.latitude ?? 0,
        longitude: eventLocation?.longitude ?? 0,
    };

    const { mapView, mapComponent, isMapLoadingFailed } = useEsriEmbeddedBaseMap({
        center: mapCenter,
        surface: 'fr-event-preview',
    });

    const mapIconTheme = getMapIconTheme();

    useSingleGraphicDisplayLayer({
        mapView,
        center: mapCenter,
        icon: {
            url: mapIconTheme.getEventIconUrl('Assigned, Inactive'),
            width: mapIconTheme.eventIconSize,
            height: mapIconTheme.eventIconSize,
        },
        label: {
            text: eventPriority,
            font: { ...ESRI_DEFAULT_ICON_LABEL_FONT, size: '10px' },
            yoffset: -2,
        },
    });

    return (
        <Box
            position="relative"
            w="100%"
            h={isMapLoadingFailed ? 'auto' : MAP_COMPONENT_HEIGHT}
            overflow="hidden"
            data-testid="fr-event-location-map"
        >
            {!mapView?.initialized && (
                <Flex w="100%" h="100%" alignItems="center" justifyContent="center">
                    <Spinner />
                </Flex>
            )}
            {!isMapLoadingFailed && <ZoomInAndOutControl mapView={mapView} btnSize="md" />}
            {isMapLoadingFailed ? (
                <InlineBanner status="error" description={errorOccurredWhile('loading the map')} />
            ) : (
                mapComponent
            )}
        </Box>
    );
});
